import { render } from "./activated-devices.vue?vue&type=template&id=edc3586c"
import script from "./activated-devices.vue?vue&type=script&lang=js"
export * from "./activated-devices.vue?vue&type=script&lang=js"
script.render = render

export default script